export enum ClaimStatus {
    NEW = 'NEW',
    INDISPUTABLE = 'INDISPUTABLE',
    DISPUTED = 'DISPUTED',
    UPHELD = 'UPHELD',
    RELEASED = 'RELEASED'
}

export enum ClaimDisputeStatus {
    NONE = 'NONE',
    DRAFT = 'DRAFT',
    SUBMITTED = 'SUBMITTED',
    REJECTED = 'REJECTED',
    APPROVED = 'APPROVED',
    INDISPUTABLE = 'INDISPUTABLE',
}

export class ClaimDisputeStatusUtils {

    public static readonly disputesOrder: string[] =
        [ClaimDisputeStatus.REJECTED, ClaimDisputeStatus.NONE, ClaimDisputeStatus.DRAFT,
            ClaimDisputeStatus.SUBMITTED, ClaimDisputeStatus.APPROVED, ClaimDisputeStatus.INDISPUTABLE];

    public static readonly possibleToDeleteViolationUnconditionally: string[] =
        [ClaimDisputeStatus.NONE, ClaimDisputeStatus.DRAFT, ClaimDisputeStatus.INDISPUTABLE];

    public static readonly possibleToDeleteViolationAfterUnlinking: string[] =
        [ClaimDisputeStatus.SUBMITTED, ClaimDisputeStatus.APPROVED, ClaimDisputeStatus.REJECTED];

    public static readonly possibleToDeleteViolation: string[] =
        [ClaimDisputeStatus.NONE, ClaimDisputeStatus.DRAFT, ClaimDisputeStatus.SUBMITTED,
            ClaimDisputeStatus.APPROVED, ClaimDisputeStatus.REJECTED, ClaimDisputeStatus.INDISPUTABLE];

    public static readonly possibleToCreateReclamation: string[] = [ClaimDisputeStatus.NONE];

    public static readonly filterable = [ClaimDisputeStatus.NONE, ClaimDisputeStatus.SUBMITTED,
        ClaimDisputeStatus.APPROVED, ClaimDisputeStatus.REJECTED, ClaimDisputeStatus.INDISPUTABLE];
}
